



















































import dayjs from 'dayjs';
import { mapState } from 'vuex';
import { Component, Vue } from 'vue-property-decorator';

import Header from '@/components/Header/Header.vue';
import Sidebar from '@/components/Sidebar/Sidebar.vue';
import SidebarItems from '@/configs/sidebar';
import Button from '@/components/Button.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import auth from '@/libs/auth';

@Component({
  components: {
    Sidebar,
    TopHeader: Header,
    Button,
    ModalDialog,
  },
  computed: mapState(['sidebarCollapsed']),
})
export default class Layout extends Vue {
  time = '';
  prevHeight = '0';
  items = SidebarItems;

  sidebarCollapsed!: boolean;

  mounted() {
    this.setTime();
    this.startTime();
    this.$store.commit('setTimeout', this.$store.state.timeoutDefault);
    this.checkLastDestroy();
  }

  // eslint-disable-next-line class-methods-use-this
  created() {
    window.addEventListener('beforeunload', () => {
      localStorage.setItem('last-destroy', dayjs().toString());
      // this.$cookies.set('last-destroy', dayjs().toString(), -1, '/', 'bayarind.id');
    });
    window.addEventListener('storage', (e) => {
      // Kalau ada tab lain yang set last-destroy ketika masih ada tab yang terbuka
      // tab yang terbuka akan menghapus last destroy
      if (e.key === 'last-destroy') {
        localStorage.removeItem('last-destroy');
        // this.$cookies.remove('last-destroy', '/', 'bayarind.id');
      }
    });
  }

  startTime() {
    const timeInterval = setInterval(() => {
      this.setTime();
      if (this.$store.state.timeoutCounter > 0) {
        // console.log('time counter');
        this.$store.commit('setTimeout', this.$store.state.timeoutCounter - 1);
      }
    }, 1000);
    this.$once('hook:beforeDestroy', () => {
      // console.log('before destroy');
      clearInterval(timeInterval);
    });
  }

  setTime() {
    this.time = dayjs().format('dddd, MMMM D, YYYY HH:mm:ss');
  }

  beforeLeave(element: HTMLElement) {
    this.prevHeight = getComputedStyle(element).height;
  }

  enter(element: HTMLElement) {
    const { height } = getComputedStyle(element);
    const el = element;

    el.style.height = this.prevHeight;

    setTimeout(() => {
      el.style.height = height;
    });
  }

  afterEnter(element: HTMLElement) {
    const el = element;
    this.prevHeight = '0';
    el.style.height = 'auto';
  }

  forceRelog() {
    this.$store.commit('doubleLogin', false);
    this.$store.commit('setTimeout', this.$store.state.timeoutCounter - 1);
    this.$cookies.remove('st', '/', 'bayarind.id');
    this.$cookies.remove('refresh_token', '/', window.location.hostname);
    window.location.href = `${process.env.VUE_APP_PRODUCTION_DOMAIN}/login`;
    auth.clearUser();
    // this.$router.push({
    //   path: '/login',
    //   query: { redirect: this.$route.fullPath },
    // });
  }

  checkLastDestroy() {
    const dateString = localStorage.getItem('last-destroy');
    // const dateString = this.$cookies.get('last-destroy');
    // console.log(dateString);
    const rt = new URLSearchParams(window.location.search);
    if (dateString && rt.get('rt') === null) {
      const dateDiff: number = dayjs().diff(dayjs(dateString), 'second');
      // console.log('last-destroy', dateDiff);
      // eslint-disable-next-line no-restricted-globals
      if (dateDiff > 10 && isNaN(dateDiff) === false) {
        this.$store.commit('setTimeout', 0);
        this.forceRelog();
      }
    }
  }
}
